const types = {
    SET_LOADING: "SET_LOADING",
    SET_CONTENT_TYPE: "SET_CONTENT_TYPE",
    SET_CHARTING_ENTRIES: "SET_CHARTING_ENTRIES",
    SET_PROVIDER_NOTES: "SET_PROVIDER_NOTES",
    SET_UNREAD_PROVIDER_NOTES_COUNT: "SET_UNREAD_PROVIDER_NOTES_COUNT",
    SET_RAW_ENTRY: "SET_RAW_ENTRY",
    SET_COMPILED_ENTRY: "SET_COMPILED_ENTRY",
    SET_QUEUED_PRESCRIPTIONS: "SET_QUEUED_PRESCRIPTIONS",
    SELECT_CHARTING_PRESCRIPTION: "SELECT_CHARTING_PRESCRIPTION",
    SET_CHARTING_TEMPLATES: "SET_CHARTING_TEMPLATES",
    RESET_CHARTING_ENTRY: "RESET_CHARTING_ENTRY",
    SELECT_TEMPLATE: "SELECT_TEMPLATE",
    SELECT_ITEM: "SELECT_ITEM",
    SET_CHARTING_NOTE_ADDED: "SET_CHARTING_NOTE_ADDED",
    EVALUATE_CHARTING_REQUIREMENTS: "EVALUATE_CHARTING_REQUIREMENTS",
    SET_MODAL_MODE: "SET_MODAL_MODE"
}

export default types